import "./App.css";
import React, { Routes, Route } from "react-router-dom";
// @ts-ignore
import About from "./Components/About.tsx";
// @ts-ignore
import Projects from "./Components/Projects.tsx";
// @ts-ignore
import Contact from "./Components/Contact.tsx";
// @ts-ignore
import ErrorPage from "./Components/ErrorPage.tsx";
import { createContext, useState } from "react";
import ReactSwitch from "react-switch";


export const ThemeContext = createContext(null);

function App() {
  
  const [theme, setTheme]= useState("dark")
  const toggleTheme = ()=>{
    setTheme((curr)=>(curr === "light"? "dark": "light"))
  }
  return (
    <ThemeContext.Provider 
// @ts-ignore
    value={{ theme, toggleTheme }}>
      <div className="App" id={theme}>
        <div className="switch">
          <header>
            <label>{theme === "light" ? "Light Mode" : "Dark Mode"}</label>
            <ReactSwitch onChange={toggleTheme} checked={theme === "dark"} />
          </header>
          <div />

          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/react-pf" element={<About />} />
            <Route path="/About" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        
        </div>
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
